class CustomImageCarouselComponent extends HTMLElement {
  constructor() {
    super();
    this.initPages();
  }
  initPages() {
    var bannerSplide = new Splide(this.querySelector('.image-carousel'), {
      type: 'loop',
      pagination : false,
      gap : 20,
      fixedWidth: 560,
      direction: 'rtl',
      arrows: false,
      breakpoints : {
        1200: {
          perPage: 1,
          perMove: 1,
          fixedWidth : false,
          gap: 8,
          padding: {left: 100},
        },
        989: {
          direction: 'ltr',
          perPage: 1,
          perMove: 1,
          padding: false
        }
      }
    });
    var titleSplide = new Splide(this.querySelector('.text-carousel'), {
      type: 'loop',
      perPage: 1,
      perMove: 1,
      isNavigation: true,
      pagination: false,
      breakpoints: {
        989: {
          type: 'slide'
        }
      }
    });
    var $this = this;
    titleSplide.on( 'mounted move', function () {
      $this.querySelector('.count .num').innerHTML = titleSplide.index + 1
    });

    bannerSplide.sync( titleSplide );
    bannerSplide.mount();
    titleSplide.mount();
  }
}

customElements.define('image-carousel', CustomImageCarouselComponent);